import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { PokemonType } from '../../types';

export const pokemonApi = createApi({
  reducerPath: 'pokemonApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://pokeapi.co/api/v2/' }), 
  endpoints: (builder) => ({
    getPokemonByName: builder.query<PokemonType, string>({
      query: (name) => `pokemon/${name}`,
    }),
  }),
});

// export hooks for usage in functional components
// auto-generated based on the defined endpoints
export const { useGetPokemonByNameQuery } = pokemonApi;
